// src/app/pages/customer/stores/customer-information.store.ts
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { CustomerFullInformation } from '../models/customer-information.model';

type CustomerInformationState = {
  customerFullInformation: CustomerFullInformation | null;
};

export const CustomerInformationStore = signalStore(
  { providedIn: 'root' },
  withState<CustomerInformationState>({ customerFullInformation: null }),
  withMethods(store => ({
    setCustomerFullInformation(payload: CustomerFullInformation): void {
      patchState(store, { customerFullInformation: payload });
    },
    reset(): void {
      patchState(store, { customerFullInformation: null });
    }
  }))
);
